import { ref } from 'vue'

import { Api } from './__generated-api'

export const apiToken = ref<string | null>(null)

export const httpService = new Api({
  baseURL: import.meta.env.VITE_API_URL
})

httpService.instance.interceptors.request.use(config => {
  if (config?.headers) config.headers.Authorization = `Bearer ${apiToken.value}`
  return config
})
